import { ApiClient } from '@/lib/apiClient';
import type { CreateTenant, Tenant } from '@/types/tenants';

export default class TenantService extends ApiClient<Tenant, CreateTenant> {

  constructor() {
    super('/v1/tenant', 'id');
  }

  async copy(params: { oldTenant: string; newTenant: string }, signal?: AbortSignal): Promise<Tenant> {
    try {

      const response = await this.apiClient.post<Tenant>(`/copy`, params, { signal })
      return response.data
    } catch (error) {
      throw error
    }
  }
}
